import MarketPricesIndex from './Index'
import FuturesIndex from './futures/Index'
import OkteIndex from './okte/Index'

export default [
  {
    path: '/market-prices',
    name: 'marketPrices',
    component: MarketPricesIndex,
    redirect: '/market-prices/futures',
    meta: {
      auth: true,
      permission: 'view market-prices',
    },
    children: [
      {
        path: 'futures',
        name: 'mpFutures',
        component: FuturesIndex,
      },
      {
        path: 'okte',
        name: 'mpOkte',
        component: OkteIndex,
      },
    ],
  },
]
